import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOet = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "nonzero",
		d: "M25.235 0A2.766 2.766 0 0 1 28 2.765v22.47A2.766 2.766 0 0 1 25.235 28H2.765A2.766 2.766 0 0 1 0 25.235V2.765A2.766 2.766 0 0 1 2.765 0zM11 23H2v2.304c0 .384.312.696.696.696H11zm10 0h-3v3h3zm-5 0h-3v3h3zm10 0h-3v3h2.304a.696.696 0 0 0 .696-.696zm-11 1v1h-1v-1zM2 18v3h9v-3zm14 0h-3v3h3zm5 0h-3v3h3zm5 0h-3v3h3zm-1 1v1h-1v-1zm-9-6h-3v3h3zm5 0h-3v3h3zm5 0h-3v3h3zm-6 1v1h-1v-1zM16 2h-3v9h3zm5 0h-3v9h3zm4.304 0H23v9h3V2.696A.696.696 0 0 0 25.304 2M11 2H2.696A.696.696 0 0 0 2 2.696V11h9zM2 16h9v-3H2z"
	})
});
export default SvgOet;
